module.exports = __webpack_public_path__ + "img/appAsset-brand--khipu.8566eb21.svg";